export default class Registration {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.registrationDate = jsonResponse["registration-date"];
        this.creationAgentId = jsonResponse["creation-agent-id"];
        this.organisationId = jsonResponse["organisation-id"];
        this.idExpiryDate = jsonResponse["id-expiry-date"];
        this.registrationType = jsonResponse["registration-type"];
        this.registrationStatus = jsonResponse["registration-status"];
        this.approvalAgentId = jsonResponse["approval-agent-id"];
        this.approvalReason = jsonResponse["approval-reason"];
        this.verifications = jsonResponse["verifications"];
        this.commissionAgentId = parseInt(jsonResponse["commission-agent-id"], 10);

    }

    static badgeColours = [
        {name: "NEW", displayName: "New", shortName: "N", colour: "primary"},
        {name: "APPROVED", displayName: "Approved", shortName: "A", colour: "success"},
        {name: "DECLINED", displayName: "Declined", shortName: "D", colour: "danger"},
        {name: "PENDING_NEW", displayName: "Pending New", shortName: "P", colour: "info"},
        {name: "SUSPENDED", displayName: "Suspended", shortName: "S", colour: "warning"},
        {name: "PENDING_UPDATE", displayName: "Pending Update", shortName: "U", colour: "info"}
    ];

}